module.exports = __webpack_public_path__ + "img/Help.3be8bf9.webp";